import { Component, Inject, Input } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'rm-access-denied-dialog',
  templateUrl: './access-denied-dialog.component.html',
  styleUrls: ['./access-denied-dialog.component.css']
})
export class AccessDeniedDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    
  }

}